import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-12\"><h1 class=\"text-center\">Une erreur est survenue 😢</h1></div></div><div class=\"row\"><div class=\"col-12\"><p class=\"text-center\"> Votre paiement n&#39;a pas pu être pris en compte par HelloAsso. <br> Une erreur est survenue. <br> Vous pouvez réessayer de payer plus tard ou nous contacter à cette adresse : <a href=\"mailto:overrun@24heures.org\"> overrun@24heures.org </a></p></div></div>", 2)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col d-flex justify-content-evenly" }
const _hoisted_6 = { class: "d-flex justify-content-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  "aspect-ratio": "1",
  class: "size-one-em",
  src: "https://backoffice.helloasso.com/Assets/dist/img/helloasso-badge.svg"
}, null, -1)
const _hoisted_9 = { class: "ms-2 m-0 p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Accéder à mon espace personnel ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("a", {
            href: _ctx.helloassoCheckoutIntentUrl,
            class: "btn btn-primary d-flex align-items-center"
          }, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, "Payer " + _toDisplayString(_ctx.centimesToEuro(_ctx.amount)) + "€", 1)
          ], 8, _hoisted_7)
        ])
      ])
    ])
  ]))
}